import { StateCreator } from "zustand";
import { MandatoryDocumentMetaData, DocumentMetadataSlice } from "./types";
import { Store } from "../../types";

export const createDocumentMetadataSlice: StateCreator<
  Store,
  [],
  [],
  DocumentMetadataSlice
> = (set) => ({
  documentAssets: {},
  initializeDocumentMetadata: (upload, assetIds) => {
    const filteredAssetIds =
      assetIds?.split(",").map(Number) ??
      upload.assets.map((asset) => asset.id);

    const assets = upload.assets
      .filter((asset) => filteredAssetIds.includes(asset.id))
      .reduce((acc: Record<number, MandatoryDocumentMetaData>, asset) => {
        const { documentMetadata } = asset;
        if (!documentMetadata) {
          return acc;
        }
        acc[documentMetadata.assetId] = {
          title: documentMetadata.title ?? null,
          contentType: asset.contentType ?? null,
          isCompliant: documentMetadata.isCompliant ?? false,
          language: asset.language ?? null,
          originalName: asset.originalName ?? undefined,
          filename: asset.filename,
          extension: asset.extension,
          validationMessage: [],
        };
        return acc;
      }, {});
    set({ documentAssets: assets });
  },
  setDocumentMetaData: (key, documentMetadata) => {
    set((state) => ({
      documentAssets: {
        ...state.documentAssets,
        [key]: {
          ...state.documentAssets[key],
          ...documentMetadata,
        },
      },
    }));
  },
  setDocumentMetadataValidation: (key, validationMessage) =>
    set((state) => ({
      documentAssets: {
        ...state.documentAssets,
        [key]: {
          ...state.documentAssets[key],
          validationMessage,
        },
      },
    })),
  resetDocumentValidationError: (key, field) =>
    set((state) => {
      const asset = state.documentAssets[key];
      if (!asset) return state;

      return {
        documentAssets: {
          ...state.documentAssets,
          [key]: {
            ...asset,
            validationMessage: asset.validationMessage.filter(
              (msg) => msg.field !== field,
            ),
          },
        },
      };
    }),
});
